import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getAllRangesByType } from '../../../redux/selectors/productRange';
import fetchProductRange from '../../../redux/actions/productRange';
import { fetchHairDiagnosis } from '../../../redux/actions/hairDiagnosis';
import { getCurrentDiagnosisUser } from '../../../redux/selectors/hairDiagnosis';

import { sendCustomerEmail } from '../../../services/api';

import TreatmentRecommendations from '../../../components/TreatmentRecommendations/TreatmentRecommendations';
import Placeholder from '../../../components/Placeholder';
import { HairStraightening, HairCut, HairTreatment, HeadSpa, Note, HairColor, Perm } from '../NewVisitPage/Treatments';

import {
  Wrapper,
  DateSubtitle,
  SectionTitle,
  Title,
  PhotosWrapper,
  Circle,
  PhotoWidgetWrapper,
  PhotoWidgetWrapperInner,
  ImageContainer,
  Hero,
  LastVisit,
  Name,
  Info,
  TreatmentsListWrapper,
  TreatmentsList,
  ButtonsWrapper,
  EmailButton,
  Spinner,
} from './VisitSummaryPage.style';

class VisitSummary extends React.Component {
  state = {
    errorOnSend: false,
    loading: false,
  };

  componentDidMount() {
    const {
      history,
      locale,
      currentDiagnosisUser,
      hairDiagnosis,
      fetchHairDiagnosis,
      match,
      fetchProductRange,
    } = this.props;
    if (!currentDiagnosisUser) {
      history.push(`/${locale}/stylist/retrieve-profile`);
    } else {
      const { ranges } = currentDiagnosisUser.diagnosisResults[0];
      ranges.forEach(range => {
        if (!this.props.ranges[range[0]] || !this.props.ranges[range[0]][range[1]]) {
          fetchProductRange(range[1], locale, range[0]);
        }
      });
    }

    if (!hairDiagnosis.title) {
      fetchHairDiagnosis(locale);
    }

    if (!match.params.id) {
      history.push(`/${locale}/stylist/retrieve-profile`);
    }
  }

  handleSendEmail = () => {
    const { currentDiagnosisUser, history, locale } = this.props;
    this.setState(
      {
        loading: true,
      },
      () => {
        sendCustomerEmail(currentDiagnosisUser.hash)
          .then(() => {
            history.push(`/${locale}/stylist/profile`);
          })
          .catch(() => {
            this.setState({
              errorOnSend: true,
              loading: false,
            });
          });
      }
    );
  };

  render() {
    const { locale, copy, ranges, currentDiagnosisUser, hairDiagnosis, match } = this.props;
    const { loading, errorOnSend } = this.state;
    const { id } = match.params;
    const diagnosisResults = currentDiagnosisUser ? currentDiagnosisUser.diagnosisResults : [{}];
    const lastUpdated = currentDiagnosisUser && new Date(currentDiagnosisUser.updatedAt);
    const currentSalonVisit = currentDiagnosisUser
      ? currentDiagnosisUser.salonVisits.find(visit => visit.id === parseInt(id, 10))
      : null;

    return (
      <Wrapper>
        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Hero>
            <LastVisit>
              {copy.last_update} {lastUpdated.getDate()}/{lastUpdated.getMonth() + 1}/{lastUpdated.getFullYear()}
              <p>{copy.salon_visit_summary}</p>
              {currentSalonVisit &&
                currentSalonVisit.stylist &&
                `${currentSalonVisit.stylist.given_name} ${currentSalonVisit.stylist.family_name} / ${
                  currentSalonVisit.stylist.city
                } ${currentSalonVisit.stylist.salon}`}
            </LastVisit>
            <Name>{diagnosisResults[0].name}</Name>
            <Info>
              {diagnosisResults[0].age} | {diagnosisResults[0].gender} | {diagnosisResults[0].city},{' '}
              {diagnosisResults[0].country}
            </Info>
          </Hero>
        ) : (
          <Hero>
            <Placeholder h="450px" w="100%" />
          </Hero>
        )}

        {currentSalonVisit && (
          <Fragment>
            {(currentSalonVisit.beforeAndAfter.before.length > 0 ||
              currentSalonVisit.beforeAndAfter.after.length > 0) && (
              <PhotoWidgetWrapper>
                <PhotoWidgetWrapperInner>
                  <DateSubtitle>
                    {lastUpdated.getDate()}/{lastUpdated.getMonth() + 1}/{lastUpdated.getFullYear()}
                  </DateSubtitle>
                  <SectionTitle>{copy.photo}</SectionTitle>
                  {currentSalonVisit.beforeAndAfter.before.length > 0 && (
                    <Fragment>
                      <Title>{copy.before}</Title>
                      <PhotosWrapper>
                        {currentSalonVisit.beforeAndAfter.before &&
                          currentSalonVisit.beforeAndAfter.before.map(url => (
                            <Circle key={url}>
                              <ImageContainer image={url} />
                            </Circle>
                          ))}
                      </PhotosWrapper>
                    </Fragment>
                  )}
                  {currentSalonVisit.beforeAndAfter.after.length > 0 && (
                    <Fragment>
                      <Title>{copy.after}</Title>
                      <PhotosWrapper>
                        {currentSalonVisit.beforeAndAfter.after &&
                          currentSalonVisit.beforeAndAfter.after.map(url => (
                            <Circle key={url}>
                              <ImageContainer image={url} />
                            </Circle>
                          ))}
                      </PhotosWrapper>
                    </Fragment>
                  )}
                </PhotoWidgetWrapperInner>
              </PhotoWidgetWrapper>
            )}

            <TreatmentsListWrapper>
              <TreatmentsList>
                {currentSalonVisit.hairCut && (
                  <li>
                    <HairCut summary copy={copy} />
                  </li>
                )}
                {currentSalonVisit.hairStraightening && (
                  <li>
                    <HairStraightening summary copy={copy} />
                  </li>
                )}
                {currentSalonVisit.hairTreatment && (
                  <li>
                    <HairTreatment summary copy={copy} />
                  </li>
                )}
                {currentSalonVisit.headSpa && (
                  <li>
                    <HeadSpa summary copy={copy} />
                  </li>
                )}
                {currentSalonVisit.notes && (
                  <li>
                    <Note value={currentSalonVisit.notes} summary copy={copy} />
                  </li>
                )}
                {currentSalonVisit.perm && (
                  <li>
                    <Perm summary copy={copy} />
                  </li>
                )}
                {currentSalonVisit.hairColorRecipes.length > 0 && (
                  <li>
                    <HairColor
                      recipes={currentSalonVisit.hairColorRecipes}
                      summary
                      treatment={{ type: 'hairColor' }}
                      copy={copy}
                    />
                  </li>
                )}
              </TreatmentsList>
            </TreatmentsListWrapper>
          </Fragment>
        )}

        {Object.keys(copy).length !== 0 &&
          copy.constructor === Object && (
            <div style={{ padding: '0 50px' }}>
              <TreatmentRecommendations
                ranges={
                  Object.keys(ranges).length === 0 && ranges.constructor === Object
                    ? []
                    : diagnosisResults[0].ranges &&
                      diagnosisResults[0].ranges.map(range => ranges[range[0]] && ranges[range[0]][range[1]])
                }
                salonImage={hairDiagnosis.summarySalonSolutionsImage}
                salonText={hairDiagnosis.summarySalonSolutionsText}
                copy={copy}
                locale={locale}
              />
            </div>
          )}

        <ButtonsWrapper>
          {errorOnSend && <p style={{ fontSize: '12px', color: 'red' }}>{copy.send_email_error}</p>}
          <EmailButton onClick={this.handleSendEmail} disabled={loading}>
            {loading ? <Spinner /> : copy.email_summary}
          </EmailButton>
          <Link to={`/${locale}/stylist/visits`} href={`/${locale}/stylist/visits`}>
            {copy.exit_summary}
          </Link>
        </ButtonsWrapper>
      </Wrapper>
    );
  }
}

VisitSummary.defaultProps = {
  copy: {},
  ranges: {},
  currentDiagnosisUser: null,
};

VisitSummary.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  ranges: PropTypes.shape({}),
  fetchProductRange: PropTypes.func.isRequired,
  currentDiagnosisUser: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  hairDiagnosis: PropTypes.shape({
    summarySalonSolutionsImage: PropTypes.shape({}),
    summarySalonSolutionsText: PropTypes.string,
  }).isRequired,
  fetchHairDiagnosis: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyStylistToolProfilePage,
  locale: state.locale,
  ranges: getAllRangesByType(state),
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  hairDiagnosis: state.hairDiagnosis,
});

const mapDispatch = dispatch => ({
  fetchProductRange: (slug, locale, rangeType) => dispatch(fetchProductRange(slug, locale, rangeType)),
  fetchHairDiagnosis: locale => dispatch(fetchHairDiagnosis(locale)),
});

export default connect(mapState, mapDispatch)(VisitSummary);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/VisitSummaryPage/VisitSummaryPage.js